import * as React from 'react';

// @ts-expect-error - imported from .js/.jsx file
import {CompanyTypeIcon} from 'shells/icon/svg/company-type-icon';

import {appHistory} from '../../../history';

import {GraphQLSelect} from './graphql-select';
import {useGetAccountTypes} from './hooks/use-get-account-types';

type Props = {
    inputId?: string;
    selectedId: string | null | undefined;
    onChange: (newValue: any) => any;
    onClearValue?: () => void;
    labelKey?: string;
    valueKey?: string;
    autoFocus?: boolean;
    autoBlur?: boolean;
    isLoading?: boolean;
    noResultsText?: string;
    styles?: any;
    menuPortalTarget?: HTMLElement;
    defaultsToFirstItem?: boolean;
    useDefaultPlaceholder?: boolean;
    hasManageOption?: boolean;
};

export const GraphQLSelectAccountTypes = (props: Props) => {
    const {isLoading, accountTypes} = useGetAccountTypes();

    return (
        <GraphQLSelect
            {...props}
            isLoading={isLoading}
            openMenuOnFocus={true}
            // @ts-expect-error
            placeholder={props.useDefaultPlaceholder ? undefined : 'Search company types…'}
            models={accountTypes}
            controlIcon={CompanyTypeIcon}
            footerButton={
                props.hasManageOption
                    ? {
                          label: 'Manage company types',
                          onClick: () => {
                              appHistory.push('/setup/company-type');
                          },
                      }
                    : undefined
            }
        />
    );
};
